import { Moment } from 'moment';
import { Rda } from './rda.model';

export class PropriedadeIntelectual {

  id: number;
  descricao: string;
  tipo: boolean;
  descricaoRegistro: string;
  dataPedido: Moment;
  situacaoPedido: boolean;
  codigoPais: number;
  rda: Rda;

  constructor(init?: Partial<PropriedadeIntelectual>) {
    Object.assign(this, init);
  }

}
